import { Stack, StackProps, Typography, styled } from '@mui/material';

const Root = styled(Stack)`
    align-items: center;
    margin-top: 48px;
    gap: 4px;
` as typeof Stack;

type NoRecordsProps = StackProps & {
    message: string;
};

export const NoRecords = (props: NoRecordsProps) => {
    const { message, children, ...other } = props;

    return (
        <Root {...other}>
            <Typography mt={1} color="text.secondary">
                {message}
            </Typography>

            {children}
        </Root>
    );
};
